export default [
  {
    label: 'Dashboard',
    to: { name: 'home' },
    icon: 'fas fa-fw fa-tachometer-alt',
  },
  {
    label: 'Compras',
    to: { name: 'filiationPurchases.list' },
    icon: 'fas fa-fw fa-shopping-cart',
  },
  {
    label: 'Assinaturas',
    to: { name: 'filiationSubscriptions.list' },
    icon: 'fas fa-fw fa-dollar-sign',
  },
  {
    label: 'Planos',
    to: { name: 'plans.list' },
    icon: 'fas fa-fw fa-tasks',
  },
  {
    label: 'Indicar produtos',
    to: { name: 'indications.list' },
    icon: 'fas fa-fw fa-bullhorn',
  },
  {
    label: 'Meus afiliados',
    to: { name: 'filiateds.list' },
    icon: 'fas fa-fw fa-sitemap',
  },
  {
    label: 'Acessos',
    to: { name: 'filiationAccess.list' },
    icon: 'fas fa-fw fa-mouse-pointer',
  },
  {
    label: 'Saldo',
    to: { name: 'balances.current' },
    icon: 'fas fa-fw fa-piggy-bank',
  },
  {
    label: 'Transferências',
    to: { name: 'transfers.list' },
    icon: 'fas fa-fw fa-exchange-alt',
  },
  {
    label: 'Conteúdo',
    icon: 'fas fa-fw fa-shapes',
    subItems: [
      {
        label: 'Meus cursos',
        to: { name: 'content.courses.list' },
        icon: 'fas fa-fw fa-graduation-cap',
      },
    ],
  },
  {
    label: 'Relatórios',
    icon: 'fas fa-fw fa-chart-pie',
    subItems: [
      {
        label: 'Meu conteúdo',
        to: { name: 'reports.videoWatches.currentMonth' },
        icon: 'fas fa-fw fa-play',
      },
      {
        label: 'Monetização',
        to: { name: 'reports.balances.month.purchases' },
        icon: 'fas fa-fw fa-hand-holding-usd',
      },
    ],
  },
  {
    label: 'Ajuda',
    icon: 'fas fa-fw fa-question',
    to: { name: 'help.list' },
  },
]
